import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch, Action } from 'redux';
import IconButton from '../common/IconButton';
import HistoryAction from '../../actions/HistoryAction';
import { getEditorKeyAndPage } from '../../helpers/integratedDrawings';
import {
  IntegratedDrawingState, getPrevDrawingPage, getNextDrawingPage, canUndoDrawing, canRedoDrawing,
} from '../../reducers/integratedDrawing';
import { PagesState } from '../../reducers/pages';
import { Publication } from '../../types/epub';
import { PageAction, AppStates } from '../../../../..';

interface UndoRedoButtonsProps {
  readonly pages: PagesState;
  readonly publication?: Publication;
  readonly integratedDrawing: IntegratedDrawingState;
  readonly dispatch: Dispatch<Action>;
}

class UndoRedoButtons extends React.PureComponent<UndoRedoButtonsProps> {
  private handleUndo = () => {
    const { pages, publication, integratedDrawing, dispatch } = this.props;
    if (publication === undefined) {
      return;
    }

    const index = getEditorKeyAndPage(pages, publication);
    const page = getPrevDrawingPage(integratedDrawing, index);
    dispatch(HistoryAction.undo());

    if (page !== null) {
      PageAction.moveToPage(pages.activeTab, page, dispatch);
    }
  }

  private handleRedoDrawing = () => {
    const { pages, publication, integratedDrawing, dispatch } = this.props;
    if (publication === undefined) {
      return;
    }

    const index = getEditorKeyAndPage(pages, publication);
    const page = getNextDrawingPage(integratedDrawing, index);
    dispatch(HistoryAction.redo());

    if (page !== null) {
      PageAction.moveToPage(pages.activeTab, page, dispatch);
    }
  }

  public render() {
    const {
      pages,
      publication,
      integratedDrawing } = this.props;

    const canUndo = publication !== undefined
      ? canUndoDrawing(integratedDrawing, getEditorKeyAndPage(pages, publication))
      : false;

    const canRedo = publication !== undefined
      ? canRedoDrawing(integratedDrawing, getEditorKeyAndPage(pages, publication))
      : false;

    return <>
      <IconButton
        title="UNDO"
        imagePath="images/tool-icons/new/undo/undo"
        rouondRect={true}
        disabled={!canUndo}
        onClick={this.handleUndo} />
      <IconButton
        title="REDO"
        imagePath="images/tool-icons/new/redo/redo"
        rouondRect={true}
        disabled={!canRedo}
        onClick={this.handleRedoDrawing} />
    </>;
  }
}

const mapStateToProps = (appStates: AppStates) => {
  const { pages, publication, integratedDrawing } = appStates;
  return { pages, publication, integratedDrawing };
};

export default connect(mapStateToProps)(UndoRedoButtons);
